export default __webpack_public_path__ + "static/media/emotion-m@3x.abbcc61e.png";